import React from 'react';
import { connect } from 'react-redux';
import { updateSettings } from '$/store/settings/actions';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import { Formik, Field, ErrorMessage } from 'formik';
import InputBlock from '$/components/global/inputBlock';
import './index.scss';
import * as Yup from 'yup';
import Loading from '$/components/loading/Loading';

interface ISettingsProps {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  settings?: Bixby.Models.Settings;
  dispatchUpdateSettings: (settings: Bixby.Models.Settings) => Promise<Bixby.Models.Settings>;
}

interface SettingsValues {
  contactUrl: string;
  disclaimer: string;
  feedbackUrl: string;
  newsCutoff: number;
}

const GeneralSettings: React.FC<ISettingsProps> = props => {
  const { isLoading, settings, dispatchUpdateSettings } = props;

  const initialSettings = settings
    ? ({
        newsCutoff: settings.newsCutoff || 0,
        disclaimer: settings.disclaimer || '',
        contactUrl: settings.contactUrl || '',
        feedbackUrl: settings.feedbackUrl || '',
      } as SettingsValues)
    : {
        newsCutoff: 0,
        disclaimer: '',
        contactUrl: '',
        feedbackUrl: '',
      };

  const schema = Yup.object({
    contactUrl: Yup.string().url('Must be a URL.').required('Contact url is required.'),
    disclaimer: Yup.string().required('Disclaimer is required.'),
    feedbackUrl: Yup.string().required('Feedback Link URL or email is required.'),
    newsCutoff: Yup.number().required('News and earning sort is required.'),
  });

  if (isLoading || !settings) {
    return <Loading pageLevel />;
  } else {
    return (
      <React.Fragment>
        <section className="settings_form">
          <Formik
            initialValues={initialSettings}
            validationSchema={schema}
            onSubmit={(values: SettingsValues) => {
              const updatedSettings = values as Bixby.Models.Settings;
              dispatchUpdateSettings(updatedSettings);
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <InputBlock title="News &amp; Earning Sort">
                  <Field type="number" min="1" max="365" name="newsCutoff" />
                </InputBlock>
                <ErrorMessage name="newsCutoff">{msg => <div className="error error-message">{msg}</div>}</ErrorMessage>
                <InputBlock title="Contact URL">
                  <Field type="text" name="contactUrl" placeholder="Enter URL" />
                </InputBlock>
                <ErrorMessage name="contactUrl">{msg => <div className="error error-message">{msg}</div>}</ErrorMessage>
                <InputBlock title="Feedback Link URL">
                  <Field type="text" name="feedbackUrl" placeholder="Enter URL" />
                </InputBlock>
                <ErrorMessage name="feedbackUrl">
                  {msg => <div className="error error-message">{msg}</div>}
                </ErrorMessage>
                <InputBlock title="Disclaimer">
                  <Field name="disclaimer" component="textarea" />
                </InputBlock>
                <ErrorMessage name="disclaimer">{msg => <div className="error error-message">{msg}</div>}</ErrorMessage>
                <div className="button_container">
                  <button className="bix_button" type="submit">
                    Save Settings
                  </button>
                </div>
              </form>
            )}></Formik>
        </section>
      </React.Fragment>
    );
  }
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.settingsState.isLoading,
    error: state.settingsState.error,
    settings: state.settingsState.settings,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchUpdateSettings: (settings: Bixby.Models.Settings) => dispatch(updateSettings(settings)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettings);
